import React from "react";

const Emergency = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Emergency Availment</h1>
      <div className='description'>
        How to avail emergency services:
        <ul id='mainList'>
          <li className='list-item bullet'>
            Member goes to the Emergency Room (ER) of an accredited hospital
          </li>
          <li className='list-item bullet'>
            Member presents his Getwell card to the Emergency Room (ER) staff
            for validation of membership status.
          </li>
          <li className='list-item bullet'>
            Medical staff calls Getwell to verify membership status
          </li>
          <li className='list-item bullet '>
            If membership status is <b>ACTIVE</b>, Getwell staff gives approval
            number for medical treatment If <b>INACTIVE</b>, member is declined
            and advised to call their employer for his/her membership status
          </li>
          <li className='list-item bullet'>Member undergoes treatment</li>
          <li className='list-item bullet'>
            If declared an Out-Patient case, member signs the outpatient charge
            slip upon discharge for billing. If for Admission, medical staff
            notifies Getwell for Letter of Authorization (LOA)of the approved
            benefits
          </li>
          <li className='list-item bullet'>
            Getwell staff notifies the agency or member-patients’ relatives to
            file PhilHealth Insurance benefits upon discharge . Any incremental
            and miscellaneous fees must be paid by the member-patients.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Emergency;
